import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  Container,
  Typography,
  makeStyles
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingTop: 74,
    paddingBottom: 74
  },
  browseButton: {
    marginLeft: theme.spacing(2)
  }
}));

const CTA = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Container maxWidth="lg">
        <Typography
          component="p"
          variant="h5"
          color="secondary"
          align="center"
        >
          ARE YOU READY?
        </Typography>

        <Box my={3}>
          <spacing />
        </Box>
        <Typography
          variant="h2"
          align="center"
          color="textPrimary"
        >
Elevate Your Brand Image Today by Harnessing the Creative Potential of Artistic QR Codes!        </Typography>
        <Box
          mt={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            color="secondary"
            component={RouterLink}
            to={{ pathname: "https://ai.qrcodes.apitier.com/register" }}
            target="_blank"
            variant="contained"
          >
            Generate Your Artistic QR Code Now!!
          </Button>
          
        </Box>
      </Container>
    </div>
  );
};

CTA.propTypes = {
  className: PropTypes.string
};

export default CTA;
